import React, { useRef } from 'react';
import ImageIcon from '@material-ui/icons/Image';

const ImageUploadButton = ({ handleChange }) => {
    const fileInputRef = useRef(null);

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        const target = e.target; // Store reference to target

        if (file && file.type.startsWith('image/')) {
            await handleChange(file);
            // Reset input so the same file can be selected again if needed
            target.value = '';
        }
    };

    return (
        <>
            <button
                onClick={handleClick}
                style={{
                    width: 36,
                    height: 34,
                    background: "transparent",
                    border: 0,
                    outline: 0,
                }}
            >
                <ImageIcon style={{ cursor: 'pointer', fill: "var(--mainText)" }} />
            </button>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
        </>
    );
};

export default ImageUploadButton;